/**
 * 共建店导入 2020-02-20
 */
import React from 'react';
import { connect } from 'dva';

import { component_tool,utils_tool, framework_tool } from '@/tool'
let { WizTypography,WizButton, WizSpin,WizTreeSelect,WizModal, WizCheckbox } = component_tool;
let { WizContainer } = framework_tool;
const { Paragraph } = WizTypography;
import { ExportExcel } from '@/components/index'
import {modelUtils} from '@/utils';
let {Session} = utils_tool;

const getParamRecord = (history) => {
  let record = {}
  let type = ""
  if (history.location) {
    
    let pattern = /^[/biz/categoryType/g][^\s]*[/fileImport/g]$/
    
    if (pattern.test(history.location.pathname)) {
      if (history.location && history.location.record) {
        type = history.location.record['type']
        record = { type}
        Session.set('categoryType', record)
      } else {
        record = Session.get('categoryType') || 0
      }
    }
  } else {
    record = Session.get('categoryType') || 0
  }
  return record
}

class QuestionTypeFileImport extends WizContainer {

  componentName = 'questionTypeFileImport';

  constructor(props) {
    super(props);
    const { type} = getParamRecord(props.history)
    this.state = {
      type
    }
  }
  
  _componentDidMount() {
      if(this?.state?.type ==2){

        this.doActions([{
          path: `questionType/normalNodeList`,
          payload: {
            key: `questionType@treeData`,
            apiParams: {type:this.state.type,state:1}
          }
      },
      ],);
      }else{

        this.doActions([{
          path: `questionType/nodeList`,
          payload: {
            key: `questionType@treeData`,
            apiParams: {type:this.state.type,state:1}
          }
      },
      ],);
      }
    const arr = [];
    this.setState({
        data: arr,
        treeData:[],
        orgNodeCategoryTree:[]
    });
}

  _handldImport(nextProps, nextState) {
    let o = nextProps['questionTypeImport']
    if (o['success']) {
      let data = o['data'];
      let str = data.replace(/<br\/>/g,"\n")
      WizModal.success({
        title:'导入成功',
        
        content: <p style={{whiteSpace: "pre-line"}}>{str}</p>
      })
      return true;
    } else {
      let str = o['msg'].replace(/<br\/>/g,"\n")
      WizModal.error({
        title:'导入失败',
        
        content: <p style={{whiteSpace: "pre-line"}}>{str}</p>
      })
      return false;
    }
  }
  _treeData(nextProps, nextState) {
    let o = nextProps['treeData']
    if (o['success']) {
        nextState['treeData'] = o['data']
    }
    return true
  }

  propsAndStateOnChange = {
    treeData:this._treeData.bind(this),
    questionTypeImport: this._handldImport.bind(this),
  }


  _render() {
    const{treeData,type} = this.state
    let infoProps = {
      title: '导入说明',
      text: [
        <Paragraph>1、从模版链接中下载模版文件</Paragraph>,
        <Paragraph>2、按照要求格式填写信息</Paragraph>,
        <Paragraph>3、当完成Excel文件的填写后，点击“上传文件”按钮上传此文件</Paragraph>,
      ]
    }
    let operateProps = {
      title: '分类导入',
      template: {
        label: '模版下载',
        fileName: '模版.xlsx',
        href: ['2','18'].indexOf(type) === -1 ? constants.files.excel_categoryTemp : constants.files.excel_categoryIncludeCodeTemp,
      }

    }
    let submit  = (file, fileData, other) => {
        const{parentId,modes} = other
      let apiPath = 'questionType/import';
      this.doAction({
        path: apiPath,
        payload: {
          key: "import",
          apiParams: {
            fileData,
            "type":type,
            "parentId":parentId || null,
            "modes":modes || null
          }
        }
      });
    }
    
    let other = [
        {
          /**
           * item的参数
           */
          item: { label: '上级分类' },
          /**
           * 渲染内容的方法
           */
          comp: (callback) => {
            return (
              <WizTreeSelect treeData={treeData} onChange={(value) => { 
              callback && callback('parentId', value) }} allowClear style={{ width: '100%' }}>
              </WizTreeSelect>
            )
          }
        },
        ['2'].indexOf(type) !== -1 ? {
          item: { label: '类型', required: true },
          comp: (callback) => {
            return (
              <WizCheckbox.Group
                options={[{ label: '考试', value: 0 }, { label: '练习', value: 1 }]}
                onChange={(value) => {callback && callback('modes', value) }} allowClear style={{ width: '100%' }}>
              </WizCheckbox.Group>
            )
          }
        }:null
      ]

    let { questionTypeLoading } = this.props;
    return (
      <WizSpin tip={'文件上传中'} spinning={questionTypeLoading}>
        <ExportExcel
          infoProps={infoProps}
          operateProps={operateProps}
          submit={submit}
          other={other}
        />
      </WizSpin>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { questionType } = state;
  const questionTypeImport = modelUtils.getModelEntity(questionType, 'import');
  const treeData = modelUtils.getModelEntity(questionType, 'questionType@treeData');
  

  //获取loading的方式
  const load = modelUtils.getLoadingState(state, 'questionType')
  return {
    questionTypeImport,
    treeData,
    ...load
  }
};

export default connect(mapStateToProps)(QuestionTypeFileImport);
